module.exports = __webpack_public_path__ + "img/레이븐.25a8f8ba.png";